var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiRadioGroup from '@material-ui/core/RadioGroup';
/**
 * Kareo wrapped component of the Material-UI RadioGroup. The prop API has been limited to props defined in RadioGroupProps.
 *
 * RadioGroup is a helpful wrapper used to group Radio components that provides an easier API, and proper keyboard accessibility to the group.
 *
 * Material-UI RadioGroup: [Docs](https://v4.mui.com/components/radio-buttons/), [API](https://v4.mui.com/api/radio-group/)
 *
 * @storybook: [RadioGroup](http://design.kareoprod.ent/design-system/?path=/story/components-inputs-radio-radiogroup--vertical-radio-group-story-book)
 */
var RadioGroup = React.forwardRef(function (props, ref) {
    return React.createElement(MuiRadioGroup, __assign({}, props, { ref: ref }));
});
RadioGroup.defaultProps = {};
RadioGroup.displayName = 'KareoRadioGroup';
export default RadioGroup;
